import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { AuthRedirectService, AuthRedirectStorageService, AuthService, SiteContextActions, TranslationService, User, UserActions, UrlPipe, I18nModule } from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { pairwise, switchMap } from 'rxjs/operators';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { CustomProductsService } from '../../custom-landing/custom-products/custom-products.service';
import { Router, NavigationEnd, ActivatedRoute, RouterLink, RouterLinkActive } from '@angular/router';
import { CustomProfileService } from 'src/app/core/services/custom-profile.service';
import { NotificationCountModel } from '../../../core/model/notification-count-model';
import { WindowRef } from '@spartacus/core';
import { RoutingService } from '@spartacus/core';
import InventoryManagementService from '../../custom-landing/inventory-unpublished-batch/inventory-management.service';
import { LanguageService } from '@spartacus/core';
import { CustomLoginService } from '../../custom-login/custom-login-form/custom-login.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { CustomPlatformBannerComponent } from '../../custom-login/custom-platform-banner/custom-platform-banner.component';
import { Store } from '@ngrx/store';
import { UserIdService } from '@spartacus/core'
import { ToastService } from 'src/app/core/services/toaster.service';
import { log } from 'console';
import { NgIf, NgClass, NgFor, AsyncPipe, SlicePipe } from '@angular/common';
import { CustomLanguageComponent } from '../custom-language/custom-language.component';
import { FormsModule } from '@angular/forms';
import { CustomFooterComponent } from '../custom-footer/custom-footer.component';
@Component({
    selector: 'app-custom-header',
    templateUrl: './custom-header.component.html',
    styleUrls: ['./custom-header.component.scss'],
    // tslint:disable-next-line:no-host-metadata-property
    host: {
        '(window:resize)': 'onResize($event)'
    },
    imports: [NgIf, CustomLanguageComponent, NgClass, NgFor, FormsModule, RouterLink, RouterLinkActive, CustomFooterComponent, AsyncPipe, SlicePipe, UrlPipe, I18nModule]
})
export class CustomHeaderComponent implements OnInit {
  account;
  contacts;
  currentRoute;
  prevurl;
  user$: Observable<User>;
  prev;
  outageCount;
  productheader = false;
  changeText;
  navlink = Array(7).fill(false);
  link: any;
  product: any;
  navigation: any;
  userName: any;
  showErrorPage = true;
  value: any;
  showUserProfile: any = false;
  showNotification: any = false;
  showMobileMenu = false;
  showMenu: any = false;
  valueUpdate: any;
  showcompany: any = false;
  screenHeight: number;
  screenWidth: number;
  isHomePage = false;
  unitArray = [];
  notificationCountModel: NotificationCountModel;
  selectedGroupCompany: any;
  groupCompanyAdminFlag: any;
  // groupCompanyUiDefaultAccount:any
  companyname: any;
  company: any = true;
  companyName: any;
  displayShipdocsFlag: boolean;
  chinaInstance: any;
  mySubscription: any;
  COI: boolean = false;
  ITB: boolean = false;
  isMobile: boolean = false;
  OpenNegotiation: boolean = true;
  menuDisplay: any;
  changeCompanyUnitArray: any;
  uidSelectedCompany: any;
  accountLanguage: any;
  currentLanguage: any;
  enableLoader = true;
  contact: any;
  companySelected: any;
  isOrder:boolean=false
  master: any;
  showLangDropdown: boolean = true;
  displayMenu =[];
  bidsOffersName:any;
  showBiometricMenu: boolean = false;
  inspectionDisplay:any;
  arrivalDisplay:any;
  deliveryDisplay: boolean;
  screeningDisplay: boolean;
  constructor(
    private auth: AuthService,
    private userService: UserAccountFacade,
    private cd: ChangeDetectorRef,
    private userAccountFacade: UserAccountFacade,
    private customProductService: CustomProductsService,
    private customProfileService: CustomProfileService,
    protected authRedirectService: AuthRedirectService,
    protected authRedirectStorageService: AuthRedirectStorageService,
    private router: Router,
    private winRef: WindowRef,
    private routingService: RoutingService,
    private inventoryManagementService: InventoryManagementService,
    private languageService: LanguageService,
    private customLoginService: CustomLoginService,
    public modalService: NgbModal,
    public store: Store,
    public userIdService: UserIdService,
    public tosatr:ToastService,
    public activeroute:ActivatedRoute,
    private translation: TranslationService,
  ) {
    //document.getElementsByTagName('cx-site-context-selector')[0].setAttribute("id","siteContext");
    this.languageService.getActive().subscribe(res => {
      this.currentLanguage = res;
    });
    this.prev = false;
    this.notificationCountModel = new NotificationCountModel(null);
  }

  islogin = false;

  // tslint:disable-next-line:use-lifecycle-interface
  ngAfterViewInit(): any {
    setTimeout(() => {
      const homeLink = document.querySelector<HTMLElement>('.homeLink');
      if (homeLink != null || !homeLink) {
        homeLink?.classList.add('nav__link--active');
      }
      this.userAccountFacade.get().subscribe(data => {
        if (data) {
          this.userName = data.name;
          this.cd.detectChanges();
        }
      });
    }, 2000);
  }
  loadAddresses(): void {
    this.userIdService.takeUserId().subscribe((userId) => {
      this.store.dispatch(new UserActions.LoadUserAddresses(userId));
      if (userId) {
        //this.store.dispatch(new AuthActions.Login());
      }
    });
  }
  ngOnInit(): void {
    //sessionStorage.setItem('selectorPref', 'false');
    // if(this.accountLanguage){
    //   this.languageService.setActive(this.accountLanguage);
    // }
    this.updateDevice();
    window.addEventListener('resize',()=>this.updateDevice());// to check mobile or desktop on resize
    this.currentRoute = this.router.url;
    this.getNotificationData();
    this.inventoryManagementService.getPrivacyPolicyData().subscribe(res=>{
      if(res==null){
        this.inventoryManagementService.getHelpData().subscribe(resp => {
          if(resp){
            this.chinaInstance = resp.chinaInstanceCheck
            console.log(this.chinaInstance);
            this.cd.detectChanges();
            this.inventoryManagementService.setPrivacyPolicyData(resp);
          }
          })
      }else{
        this.chinaInstance = res.chinaInstanceCheck;
        this.cd.detectChanges();
      }
    });
    //this.loadAddresses();
    document.addEventListener('click', function (e) {
      if (document.getElementById('navbarDropdown5') && !document.getElementById('navbarDropdown5').contains(e.target as Node)) {
        document.getElementById('profileMenu') ? document.getElementById('profileMenu').classList.add('d-none') : '';
      } else {
        document.getElementById('profileMenu') ? document.getElementById('profileMenu').classList.remove('d-none') : '';
      }
    });
    document.addEventListener('click', function (e) {
      if (document.getElementById('navbarDropdown4') && !document.getElementById('navbarDropdown4').contains(e.target as Node)) {
        document.getElementById('notificationMenu') ? document.getElementById('notificationMenu').classList.add('d-none') : '';
      } else {
        document.getElementById('notificationMenu') ? document.getElementById('notificationMenu').classList.remove('d-none') : '';
      }
    });

    if (this.router.url === '/inventory/inventorymanagement' || this.router.url === '/inventory/inventorydetailspages' || this.router.url === '/inventory/inventorylogin' || this.router.url === '/inventory/inventoryupdatepassword') {
      document.querySelector('header').style.display = 'none';
      document.querySelector('footer').style.display = 'none';
    }

    this.user$ = this.auth.isUserLoggedIn().pipe(
      switchMap((isUserLoggedIn) => {
        if (isUserLoggedIn) {
          // if(this.router.url === '/help'){
          // document.querySelector('header').style.display = 'none';
          //  document.querySelector('footer').style.display = 'none';
          // }
          if (this.router.url == '/') {
            this.navlink = Array(7).fill(false);
            this.navlink[4] = true;
          }
          if (this.router.url === '/products' || this.router.url == '/') {
            this.navlink = Array(7).fill(false);
            this.navlink[0] = false;
            this.cd.detectChanges();
            this.navigation = '';
            this.value = document.querySelector('header').style.backgroundImage = 'None';
            //  this.value = document.querySelector('header').style.height = '383px';
            //this.value = document.querySelector('header').style.margin = '0px 0px -29px 0px';
            const resolution = window.innerWidth;
            if (resolution < 994) {
              this.value = document.querySelector('header').style.backgroundImage = 'None';
            }
          }
          this.userAccountFacade.get().subscribe(data => {
            if (data) {
              this.userName = data.name;
              this.cd.detectChanges();
              this.getBhpUnit();
              // this.getNotificationData();
              // this.customProductService.notificationChnageSub$.subscribe(res=>{
              //   this.getNotificationData();
              // });
              // this.customProductService.languageChange$.pipe(pairwise()).subscribe(([previous, current]) => {
              //   if (previous !== current) {
              //     if (current != null) {
              //       // this.winRef.localStorage.setItem('groupCompany', undefined);
              //       // this.winRef.localStorage.setItem('groupCompanyName', undefined);
              //       this.winRef.localStorage.setItem('grpCompanyName', undefined);
              //       this.getBhpUnit();
              //       //this.getNotificationData();
              //     }
              //   }
              // });
            }
          });
          // tslint:disable-next-line:prefer-const
          return this.userService.get();
        } else {

          // tslint:disable-next-line:prefer-const
          //this.authRedirectStorageService.setRedirectUrl()
          this.winRef.localStorage.setItem('groupCompany', undefined);
          this.winRef.localStorage.setItem('groupCompanyName', undefined);
          this.winRef.localStorage.setItem('groupCompanyAdminFlag', undefined);
          // this.winRef.localStorage.setItem('groupCompanyUiDefaultAccount', undefined);
          this.winRef.localStorage.setItem('companyName', undefined);
          this.winRef.localStorage.setItem('grpCompanyName', undefined);
          this.navigation = 'logout';
          const resolution = window.screen.availWidth;
          if (resolution < 990) {
            this.value = document.querySelector('header').style.backgroundImage = 'None';
            this.value = document.querySelector('header').style.height = '120px';
            this.value = document.querySelector('header').style.margin = '0px';
          }
          return of(undefined);
        }
      })
    );

    this.customProductService.homeLinkActive$.subscribe(res => {
      if (res) {
        this.navlink[0] = true;
        // this.navigation = 'product';
        // tslint:disable-next-line:no-shadowed-variable
        this.auth.isUserLoggedIn().subscribe(resp => {
          if (resp) {
            this.getBhpUnit();
            // this.getNotificationData();
            this.changeclr(0, '');
          }
        });
      } else {
        //  this.getNotificationData();
        this.getBhpUnit();
        this.navlink[0] = false;
        this.changeclr(-1, '');
      }
    });
    let loginData = JSON.parse(localStorage.getItem('loginData'));
    let displayPopup = JSON.parse(localStorage.getItem('displayPopuop'));
    if (displayPopup == true && this.router.url != '/login' && this.router.url != '/login/forgot-password' && this.router.url != '/login/otp') {
      let ngmodatoptions: NgbModalOptions = {
        backdrop: 'static',
        keyboard: false,
        centered: true,
        size: 'lg'
      }
      this.customProfileService.getConsentUpdateDetails(loginData.email, loginData.lastConsentModified_Terms, loginData.currentDocDate_Privacy, loginData.currentDocDate_Terms, loginData.lastConsentModified_Privacy).subscribe(res => {
        if (res.displayPlatformTCUpdatesPopup == true) {
          const modalRef = this.modalService.open(CustomPlatformBannerComponent, ngmodatoptions);
          modalRef.componentInstance.platformBannerList = res;
          modalRef.componentInstance.UID = loginData.UID;
        }
      })
    }
  }
  updateDevice(){
    this.isMobile=window.innerWidth<=760
  }
  changeclr(i: any, route: string): any {
    this.showMobileMenu = false;
    // tslint:disable-next-line:prefer-const
    let menuElement = document.querySelector<HTMLElement>('.menuEffects');
    if (menuElement) {
      menuElement.classList.remove('menu-open');
    }
    if (i !== -1) {
      this.navlink = Array(8).fill(false);
      this.navlink[i] = true;
      this.cd.detectChanges();
    }
    // if(i !== 3){
    //   this.navlink[3] = false;
    //   this.cd.detectChanges();
    // }
    this.companySelected = this.winRef.localStorage.getItem('groupCompany')
    this.changeCompanyUnitArray = this.unitArray.filter(x => {
      return x.uid == this.companySelected;
    });
    this.customProfileService.companyNameChange.next(this.companySelected);
    this.bidsOffersName=this.changeCompanyUnitArray[0]?.bidsOffersName;
    if(!this.bidsOffersName){
      return;
    }
    if(this.bidsOffersName==='Orders'){
      this.customProfileService.setbidsOrderseData('Orders');
    }
    else{
      this.customProfileService.setbidsOrderseData('Bids & offers');
    }
    this.isOrder=this.changeCompanyUnitArray[0]?.bidsOffersName==='Orders'
    this.customProfileService.setbidsOrderseData(this.bidsOffersName);
    this.menuDisplay = this.changeCompanyUnitArray[0]?.menuDisplay;
    console.log(this.menuDisplay)
    this.displayMenu = this.getTrueKeys(this.menuDisplay);
    console.log(this.displayMenu);
    this.inspectionDisplay = this.hasInspection();
    this.arrivalDisplay = this.hasArrival();
    this.deliveryDisplay = this.hasDelivery();
    this.screeningDisplay = this.hasScreening();
    this.hasChildren();
    if (i === 0 || i === 3) {
      if (this.router.url === '/' || this.router.url === '/products') {
        this.navigation = '';
        this.value = document.querySelector('header').style.backgroundImage = 'None';
        //  this.value = document.querySelector('header').style.height = '383px';
        //  this.value = document.querySelector('header').style.margin = '0px 0px -29px 0px';
        // tslint:disable-next-line:prefer-const
        //  let resolution = window.screen.availWidth;
        const resolution = window.innerWidth;
        if (resolution < 994) {
          this.value = document.querySelector('header').style.backgroundImage = 'None';
        }
      } else if (this.isHomePage && i === 0) {
        // this.navigation = 'product';
        // this.value = document.querySelector('header').style.backgroundImage = 'url(\'../../../../../public/images/truck.png\')';
        // this.value = document.querySelector('header').style.height = '383px';
        // this.value = document.querySelector('header').style.margin = '0px 0px -29px 0px';
        // tslint:disable-next-line:prefer-const
        let resolution = window.innerWidth;
        if (resolution < 994) {
          this.value = document.querySelector('header').style.backgroundImage = 'None';
          this.value = document.querySelector('header').style.height = 'auto';
        }
      }
    }
    else {
      this.navigation = 'else';
      const homeLink = document.querySelector<HTMLElement>('.homeLink');
      if (homeLink) {
        homeLink.classList.remove('nav__link--active');
      }
      this.value = document.querySelector('header').style.backgroundImage = 'None';
      this.value = document.querySelector('header').style.height = 'auto';
      this.value = document.querySelector('header').style.margin = '0px';
      // document.querySelector<HTMLElement>('.mobimage').style.display = 'None';
    }
    if (route == '/opentenders') {
      this.router.navigate(['/opentenders']).then(() => {
        location.reload();
      })
    }
    else if (route == '/quotes/myquotes') {
      this.router.navigate(['/quotes/myquotes']).then(() => {
        location.reload();
      })
    }
  }
  menu(): any {
    this.showMenu = true;
    this.value = document.querySelector('header').style.backgroundImage = 'None';

  }
  openMobileMenu(): any {
    if (!this.showMobileMenu) {
      this.showMobileMenu = !this.showMobileMenu;
      document.querySelector<HTMLElement>('.menuEffects').classList.add('menu-open');
    } else {
      this.showMobileMenu = !this.showMobileMenu;
      document.querySelector<HTMLElement>('.menuEffects').classList.remove('menu-open');
    }
  }
  homeLinkClick(value): any {
    if (value) {
      this.isHomePage = true;
    }
    this.customProductService.getHomeLinkActive(value);
    this.customProductService.getMasterData().subscribe({
      next: (res) => {
        if(res)
        this.customProductService.setAgentInvoiceActive(res.isAgentInvoiceActive);
      },
      error: (err) => {
        this.tosatr.show('Server error while getting master data, please contact support team')
      }
    })
  }


  changeGrpCompany(event): any {
    localStorage.setItem('selectorPref', 'false');
    const selectEl = event.target;
    const selectedCompany = selectEl.value;
    const adminFlag = selectEl.options[selectEl.selectedIndex].getAttribute('adminFlag');
    // const uiDefaultAccount=selectEl.options[selectEl.selectedIndex].getAttribute('uiDefaultAccount');
    const companyName = selectEl.options[selectEl.selectedIndex].getAttribute('companyName');
    this.companyname = companyName;
    this.winRef.localStorage.setItem('groupCompany', selectedCompany);
    this.selectedGroupCompany = selectedCompany;
    this.winRef.localStorage.setItem('grpCompanyName', companyName);
    // this.winRef.localStorage.setItem('groupCompanyUiDefaultAccount', uiDefaultAccount);
    this.winRef.localStorage.setItem('groupCompanyAdminFlag', adminFlag);
    this.winRef.localStorage.setItem('groupCompanyName', companyName);
    this.getNotificationData();
    this.customProfileService.companyChangeClicked();
    this.changeCompanyUnitArray = this.unitArray.filter(x => {
      return x.uid == selectedCompany;
    });
    this.LanguageDropDownShoworHide();
    this.customProfileService.companyNameChange.next(selectedCompany);
    this.menuDisplay = this.changeCompanyUnitArray[0].menuDisplay;
    console.log(this.menuDisplay)
    this.bidsOffersName=this.changeCompanyUnitArray[0]?.bidsOffersName==='Orders'?'Orders':'Bids & offers'
    this.isOrder=this.changeCompanyUnitArray[0]?.bidsOffersName==='Orders'
    this.customProfileService.setbidsOrderseData(this.bidsOffersName);
    this.displayMenu = this.getTrueKeys(this.menuDisplay);
    console.log(this.displayMenu);
    this.inspectionDisplay = this.hasInspection();
     this.arrivalDisplay = this.hasArrival();
    this.deliveryDisplay = this.hasDelivery();
    this.screeningDisplay = this.hasScreening();
    this.hasChildren();
    this.displayShipdocsFlag = this.changeCompanyUnitArray[0].shipsDocdisplayFlag;

    this.languageService.setActive(this.changeCompanyUnitArray[0].uiDefaultLanguagePref);

    this.store.dispatch(new SiteContextActions.SetActiveLanguage(this.changeCompanyUnitArray[0].uiDefaultLanguagePref));
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      let relUrl = '';

      if (this.menuDisplay?.defaultLandingPage == 'materials') {
        relUrl = '/products'
      }
      else if (this.menuDisplay?.defaultLandingPage == 'bhpTeam') {
        relUrl = '/bhpteam'
      } else if (this.menuDisplay?.defaultLandingPage == 'bidsAndOffers') {
        relUrl = '/quotes/myquotes'
      }
      else if (this.menuDisplay?.defaultLandingPage == 'shipsAndDocs') {
        relUrl = '/shipment'
      }
      else if (this.menuDisplay?.defaultLandingPage == 'myCompany') {
        relUrl = '/companies/myCompany/groupcompanies/detail'
      }
      else if (this.menuDisplay?.defaultLandingPage == 'invitationToBid') {
        relUrl = '/opentenders'
      } 
      else if (this.menuDisplay?.defaultLandingPage == 'shipment') {
        relUrl = '/shipmentvms/shipmentvmslist/portside'
      }
      if (relUrl) {
        localStorage.setItem('defaultLandingPage', relUrl);
      }
      this.router.navigate([relUrl])
      //this.router.navigate(['/products'])
    });

  }

  LanguageDropDownShoworHide() {
    
    if (this.changeCompanyUnitArray[0]?.uiLanguagesPref) {
      console.log(this.changeCompanyUnitArray[0]?.uiLanguagesPref.split(",").length);
      if (this.changeCompanyUnitArray[0]?.uiLanguagesPref.split(",").length === 1) {
        this.showLangDropdown = false;
        
        // if (document.getElementById('languageDropdown')) {
        //   console.log('hide called')
        //   document.getElementById('languageDropdown').classList.add('hideLangDropdown')
        //   this.cd.detectChanges()
        // }
        // if (document.getElementById('languageDropdownMob')) {
        //   console.log('hide mob called')
        //   document.getElementById('languageDropdownMob').classList.add('hideLangDropdown')
        //   this.cd.detectChanges()
        // }
      } else {
        this.showLangDropdown = true;
        // if (document.getElementById('languageDropdown')) {
        //   document.getElementById('languageDropdown').classList.remove('hideLangDropdown')
        //   this.cd.detectChanges()
        // }
        // if (document.getElementById('languageDropdownMob')) {
        //   document.getElementById('languageDropdownMob').classList.remove('hideLangDropdown')
        //   this.cd.detectChanges()
        // }
      }
    }
    else{
      if(this.currentRoute=='/login' || this.currentRoute=='/login/forgot-password' || this.currentRoute=='/login/otp'  ){
        this.showLangDropdown = true;
      }
      else{
        this.showLangDropdown = false;
      }
    }
    
  }

  changecompany(item): any {
    localStorage.setItem('selectorPref', 'false');
    if (item.name) {
      const selectEl = item.target;
      const selectedCompany = item.uid;
      this.companyname = item.name;
      this.selectedGroupCompany = item.uid;
      this.winRef.localStorage.setItem('groupCompanyName', item.name);
      this.winRef.localStorage.setItem('groupCompany', item.uid);
      // this.winRef.localStorage.setItem('groupCompanyUiDefaultAccount', item.uiDefaultAccount);
      this.winRef.localStorage.setItem('groupCompanyAdminFlag', item.adminFlag);
      this.getNotificationData();
      this.customProfileService.companyChangeClicked();
      this.displayShipdocsFlag = this.unitArray.filter(x => {
        return x.uid == this.selectedGroupCompany;
      })[0].shipsDocdisplayFlag;

      this.changeCompanyUnitArray = this.unitArray.filter(x => {
        return x.uid == selectedCompany;
      });
      this.LanguageDropDownShoworHide();
      this.customProfileService.companyNameChange.next(selectedCompany);
      this.bidsOffersName=this.changeCompanyUnitArray[0]?.bidsOffersName==='Orders'?'Orders':'Bids & offers'
      this.customProfileService.setbidsOrderseData(this.bidsOffersName);
      this.menuDisplay = this.changeCompanyUnitArray[0].menuDisplay;
      if(this.menuDisplay !== null && this.menuDisplay !== undefined){
      this.displayMenu = this.getTrueKeys(this.menuDisplay);
      this.inspectionDisplay = this.hasInspection();
       this.arrivalDisplay = this.hasArrival();
      this.deliveryDisplay = this.hasDelivery();
      this.screeningDisplay = this.hasScreening();
      }
        this.hasChildren();  
      if (this.chinaInstance === 'true') {
        this.routingService.go({
          cxRoute: 'home',
        });
      } else {
        this.routingService.go({
          cxRoute: 'shipment',
        });
      }
      // this.routingService.go({
      //   cxRoute: 'home'
      // });
      this.languageService.setActive(this.changeCompanyUnitArray[0].uiDefaultLanguagePref);
      this.store.dispatch(new SiteContextActions.SetActiveLanguage(this.changeCompanyUnitArray[0].uiDefaultLanguagePref));
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        let relUrl = '';
        if (this.menuDisplay?.defaultLandingPage == 'materials') {
          relUrl = '/products'
        }
        else if (this.menuDisplay?.defaultLandingPage == 'bhpTeam') {
          relUrl = '/bhpteam'
        } else if (this.menuDisplay?.defaultLandingPage == 'bidsAndOffers') {
          relUrl = '/quotes/myquotes'
        }
        else if (this.menuDisplay?.defaultLandingPage == 'shipsAndDocs') {
          relUrl = '/shipment'
        }
        else if (this.menuDisplay?.defaultLandingPage == 'myCompany') {
          relUrl = '/companies/myCompany/groupcompanies/detail'
        }
        else if (this.menuDisplay?.defaultLandingPage == 'invitationToBid') {
          relUrl = '/opentenders'
        }
        else if (this.menuDisplay?.defaultLandingPage == 'shipment') {
          relUrl = '/shipmentvms/shipmentvmslist/portside'
        }       
        this.router.navigate([relUrl])
        //this.router.navigate(['/products'])
      });
    }

  }
  hasChildren():boolean{
      return this.menuDisplay.shipsAndDocsCons==='show'||this.menuDisplay.shipsAndDocsRail==='show'
    }
  companydropdown(): any {
    this.company = !this.company;
    this.showcompany = false;
  }
  groupcompanydropdown(): any {
    this.showcompany = !this.showcompany;
    this.company = true;
  }
  // tslint:disable-next-line:typedef
  onResize(event) {
    if (event.target.innerWidth < 994) {
      this.value = document.querySelector('header').style.backgroundImage = 'None';
      this.value = document.querySelector('header').style.height = 'auto';
    } else {
      if (this.router.url === '/products' || this.router.url === '/') {
        document.querySelector('header').style.backgroundImage = 'None';
      }

    } // window width
  }
// code for dynamic menus
   getTrueKeys(obj) {
    return Object.keys(obj).filter(key => obj[key] === 'show' && key!=='shipsAndDocsRail'&&key!=='shipsAndDocsCons');
  }
  getBhpUnit(): void {
    let userfromfacade: any;
    this.userAccountFacade.get().subscribe((user: any) => {
      if (user != undefined) {
        userfromfacade = user.email;
      }
    })
    let userid = userfromfacade ? userfromfacade : localStorage.getItem('email')
    if (userid) {
      this.customProfileService.getBhpData(userid).subscribe(res => {
        if (res) {
          this.unitArray = res.myB2BUnits;
          this.showBiometricMenu = res.isBiometricEnabled;
          //this.unitArray.sort(function(a,b){return b.uiDefaultAccount-a.uiDefaultAccount});
          let grpCompany = this.winRef.localStorage.getItem('groupCompany');
          const groupCompanyName = this.winRef.localStorage.getItem('groupCompanyName');
          const grpCompanyName = this.winRef.localStorage.getItem('grpCompanyName');
          const groupCompanyAdminFlag = this.winRef.localStorage.getItem('groupCompanyAdminFlag');
          // const groupCompanyUiDefaultAccount = this.winRef.localStorage.getItem('groupCompanyUiDefaultAccount');
          if (grpCompany === 'undefined' || grpCompany == null) {
            //this.winRef.localStorage.setItem('groupCompany', res.myB2BUnits[0].uid);
            this.uidSelectedCompany = this.unitArray.filter(x => {
              return x?.uiDefaultAccount == true;
            });
            if (this.uidSelectedCompany && this.uidSelectedCompany.length > 0) {
              this.uidSelectedCompany = this.uidSelectedCompany
            } else {
              this.uidSelectedCompany.push(this.unitArray[0]);
            }
            this.winRef.localStorage.setItem('groupCompany', this.uidSelectedCompany[0].uid);
            this.selectedGroupCompany = this.winRef.localStorage.getItem('groupCompany');
          } else {
            this.selectedGroupCompany = this.winRef.localStorage.getItem('groupCompany');
          }
          grpCompany = this.winRef.localStorage.getItem('groupCompany');
          this.changeCompanyUnitArray = this.unitArray.filter(x => {
            return x.uid == grpCompany;
          });
          this.displayShipdocsFlag = this.changeCompanyUnitArray[0]?.shipsDocdisplayFlag;
          this.bidsOffersName=this.changeCompanyUnitArray[0]?.bidsOffersName==='Orders'?'Orders':'Bids & offers'
          this.isOrder=this.changeCompanyUnitArray[0]?.bidsOffersName==='Orders'
          this.customProfileService.setbidsOrderseData(this.bidsOffersName);
          // this.menuDisplay = this.changeCompanyUnitArray[0]?.menuDisplay || this.unitArray[0]?.menuDisplay;       
          this.menuDisplay = this.changeCompanyUnitArray[0]?.menuDisplay;
          if(this.menuDisplay !== null && this.menuDisplay !== undefined){
          //code for dynamic menu        
          this.displayMenu = this.getTrueKeys(this.menuDisplay);
          console.log(this.displayMenu);
          this.inspectionDisplay = this.hasInspection();
           this.arrivalDisplay = this.hasArrival();
          this.deliveryDisplay = this.hasDelivery();
          this.screeningDisplay = this.hasScreening();
           this.hasChildren();
          
          }
          //       if(this.chinaInstance==='true' && this.menuDisplay?.defaultLandingPage=='shipsAndDocs'){
          //         const currentUrl = this.router.url;
          //         this.router.navigate(['/shipment/shipmentProduct'])
          //          this.contact=localStorage.getItem("contactId");
          //   if ( currentUrl=== `/companies/myCompany/contacts/detail/Update/${this.contact}`||currentUrl==='/contacts'|| currentUrl ==='/shipment/shipmentProduct'|| currentUrl=== '/shipment/details'|| currentUrl=== '/profile/my-account/change-password'|| currentUrl === '/profile/my-account/update-personal-details'||currentUrl === '/bhpteam'||currentUrl === '/companies/myCompany/contacts/detail'||  currentUrl === '/companies/myCompany/groupcompanies/detail' ||  currentUrl === '/companies/myCompany/groupcompanies/detail/updateDetails' ) {
          //       this.router.navigate([currentUrl]);
          // }          
          //  this.languageService.setActive(this.changeCompanyUnitArray[0]?.uiDefaultLanguagePref);
          //         this.cd.detectChanges();
          //       }
          this.accountLanguage = this.changeCompanyUnitArray[0]?.uiDefaultLanguagePref ? this.changeCompanyUnitArray[0]?.uiDefaultLanguagePref : sessionStorage.getItem('language');
          //language change based on account language
          // if(this.accountLanguage !== this.currentLanguage){
          if (localStorage.getItem('selectorPref') == 'false' || localStorage.getItem('selectorPref') == null) {
            this.languageService.setActive(this.accountLanguage);
            this.store.dispatch(new SiteContextActions.SetActiveLanguage(this.accountLanguage));
          } else {
            this.languageService.setActive(this.currentLanguage);
            this.store.dispatch(new SiteContextActions.SetActiveLanguage(this.currentLanguage));
          }
           //this.getMasterData();
          //  }




         this.LanguageDropDownShoworHide();
          // if(this.changeCompanyUnitArray[0]?.uiLanguagesPref){
          //   if(this.changeCompanyUnitArray[0]?.uiLanguagesPref.split(",").length >= 1){
          //    document.getElementById('siteContext').remove();
          //   }
          // }
          if (groupCompanyName === 'undefined') {
            this.winRef.localStorage.setItem('groupCompanyName', res.myB2BUnits[0].name);
            this.companyname = this.winRef.localStorage.getItem('groupCompanyName');
          } else {
            this.companyname = this.winRef.localStorage.getItem('groupCompanyName');
          }

          if (grpCompanyName === 'undefined') {
            this.winRef.localStorage.setItem('grpCompanyName', res.myB2BUnits[0].name);
            this.companyName = this.winRef.localStorage.getItem('grpCompanyName');
          } else {
            this.companyName = this.winRef.localStorage.getItem('grpCompanyName');
          }

          if (groupCompanyAdminFlag === 'undefined') {
            this.winRef.localStorage.setItem('groupCompanyAdminFlag', res.myB2BUnits[0].adminFlag);
            this.groupCompanyAdminFlag = this.winRef.localStorage.getItem('groupCompanyAdminFlag');
          } else {
            this.groupCompanyAdminFlag = this.winRef.localStorage.getItem('groupCompanyAdminFlag');
          }
          //  this.getNotificationData();
          this.cd.detectChanges();
        }
      });
    }

  }
  // checkMenuToDisplay(menuName: string){
  //   return this.menuDisplay.indexOf(menuName)!==-1?true:false
  // }
  getNotificationData(): void {
    this.userAccountFacade.get().subscribe(data => {
      if (data) {
        this.userName = data.name;
        if (this.userName) {
          this.customProfileService.getNotificationCount().subscribe(res => {
            this.notificationCountModel = new NotificationCountModel(res);
            this.cd.detectChanges();
          });
        }
      }
    });
  }

  goToITB() {
    this.router.navigate(['/opentenders'])
  }
  goToBidsAndOffers() {
    this.router.navigate(['/quotes/myquotes'])
  }
  goToHelp() {
    this.router.navigate(['/help'])
  }
  getMasterData(): void {
    this.enableLoader = true;
    this.customProfileService.getMasterData().subscribe({
      next:(res:any)=>{
        this.master = res;
        this.chinaInstance = this.master?.chinaInstanceCheck;
        this.enableLoader = false;
        this.cd.detectChanges()
      },
      error:(error:any)=>{
        this.enableLoader = false;
        this.tosatr.show('Server error while getting master data, please contact support team')
      }
    })
  }
// code for dynamic menu display
  onSelectChange(event: any) {
    const selectedValue = event.target.value;
     const index = this.displayMenu.indexOf(selectedValue)
     if (index > -1) {
       console.log('Selected item:', selectedValue);
       //remove the selected item from the array
       this.displayMenu.splice(index, 1);
       //add the selected item to the displayed list
       this.displayMenu.splice(7, 0, selectedValue);
       //reset the select element
       event.target.value = '';
     }
  }
  
  hasInspection(){
    return this.displayMenu.includes('inspection');
  }
  hasArrival(){
    return this.displayMenu.includes('shipment');
  }
  hasScreening(){
    return this.displayMenu.includes('screening');
  }
  hasDelivery(){
    return this.displayMenu.includes('batches');
  }
  switchTab(d){
    this.translation
        .translate('home.navigationMenus.'+d+'.route')
        .subscribe((res) => {
         this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          console.log(res);
          this.router.navigate([res]);
        });
        });
  }
  navigateHomeAndThenRoute(route:string){
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([route]);
    });
  }
  logoutClick(){
    this.customProfileService.logoutUser().subscribe({
      next: (res:any) => {
        this.router.navigate(['/logout']);
        console.log('Logout successful', res);
      },
      error: (error:any) => {
        console.error('Logout failed', error);
      }
    })
  }
  
}

